<template>
  <span>
    <b-tooltip
      :label="$t(`Orders.${state}`)"
      :position="tooltipPosition"
      :type="type"
    >
      <b-icon
        :class="stateComunication.css"
        :icon="stateComunication.icon"
        size="is-small"
      >
      </b-icon>
    </b-tooltip>
  </span>
</template>

<script>
export default {
  name: 'TransportComunications',
  props: {
    state: {
      type: String,
      default: ''
    },
    tooltipPosition: {
      type: String,
      default: 'is-top'
    },
    type: {
      type: String,
      default: 'is-dark'
    }
  },
  computed: {
    stateComunication () {
      const states = {
        PENDENT: {
          icon: 'check',
          css: 'green-status'
        },
        REPORTED: {
          icon: 'check-all',
          css: 'green-status'
        },
        ERROR_NEWOFFERPICKUP: {
          icon: 'close',
          css: 'red-status'
        },
        ERROR_COMMUNICATING: {
          icon: 'close',
          css: 'red-status'
        },
        INVALID_FIELDS: {
          icon: 'alarm-light-outline',
          css: 'red-status'
        },
        CONSULTED: {
          icon: 'bullhorn-outline',
          css: 'orange-status'
        },
        IN_PROGRESS: {
          icon: 'autorenew',
          css: 'orange-status'
        },
        DEFAULT: {
          icon: '',
          css: ''
        }
      }

      return states[this.$props.state] || states['DEFAULT']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/miscellaneous/TransportCommunications.vue